import React, { useState } from 'react';
import { PhoneIcon, MenuIcon, XIcon } from 'lucide-react';
import { ContactModal } from './ContactModal';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <>
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-134" />
      <nav className="bg-navy border-t-4 border-orange sticky top-0 z-50 shadow-xl" data-id="element-135">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136">
          <div className="flex justify-between h-24 items-center" data-id="element-137">
            {/* Logo */}
            <div className="flex-shrink-0 flex items-center" data-id="element-138">
              <img className="h-20 w-auto transform hover:scale-105 transition-transform duration-300 drop-shadow-lg" src="https://cdn.magicpatterns.com/uploads/6yupxKuByE6KFzX9hkPWGk/State_48_HVAC_Logo.png" alt="State 48 Home Comfort Logo" data-id="element-139" />
            </div>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-8" data-id="element-140">
              <a href="#" className="font-sub text-lg text-cream hover:text-orange transition-colors tracking-wide uppercase" data-id="element-141">
                Home
              </a>
              <a href="#services" className="font-sub text-lg text-cream hover:text-orange transition-colors tracking-wide uppercase" data-id="element-142">
                Services
              </a>
              <a href="#story" className="font-sub text-lg text-cream hover:text-orange transition-colors tracking-wide uppercase" data-id="element-143">
                Our Story
              </a>
              <a href="#reviews" className="font-sub text-lg text-cream hover:text-orange transition-colors tracking-wide uppercase" data-id="element-144">
                Reviews
              </a>

              {/* Desktop: open modal */}
              <button onClick={() => setIsModalOpen(true)} className="flex items-center bg-orange hover:bg-orange-600 text-white px-6 py-2 rounded-sm transform -skew-x-12 transition-all shadow-lg group" data-id="element-145">
                <div className="skew-x-12 flex items-center gap-2" data-id="element-146">
                  <PhoneIcon className="h-5 w-5 fill-current" data-id="element-147" />
                  <span className="font-display text-xl tracking-wider" data-id="element-148">
                    602-584-2141
                  </span>
                </div>
              </button>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden flex items-center" data-id="element-149">
              <button onClick={() => setIsOpen(!isOpen)} className="text-cream hover:text-orange p-2" aria-label="Toggle menu" data-id="element-150">
                {isOpen ? <XIcon className="h-8 w-8" data-id="element-151" /> : <MenuIcon className="h-8 w-8" data-id="element-152" />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && <div className="md:hidden bg-navy border-t border-navy-700" data-id="element-153">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-154">
              <a href="#" className="block px-3 py-2 text-cream hover:text-orange font-sub text-xl uppercase" data-id="element-155">
                Home
              </a>
              <a href="#services" className="block px-3 py-2 text-cream hover:text-orange font-sub text-xl uppercase" data-id="element-156">
                Services
              </a>
              <a href="#story" className="block px-3 py-2 text-cream hover:text-orange font-sub text-xl uppercase" data-id="element-157">
                Our Story
              </a>
              <a href="#reviews" className="block px-3 py-2 text-cream hover:text-orange font-sub text-xl uppercase" data-id="element-158">
                Reviews
              </a>
              {/* Mobile: direct tel: call */}
              <a href="tel:6025842141" className="block px-3 py-4 text-orange font-display text-2xl" data-id="element-159">
                <span className="flex items-center gap-2" data-id="element-160">
                  <PhoneIcon className="h-5 w-5" data-id="element-161" />
                  602-584-2141
                </span>
              </a>
            </div>
          </div>}
      </nav>
    </>;
}